
export const FORM_SUBMITTED = "FORM_SUBMITTED";

export const contactUsAction = () => dispatch => {
    dispatch({ type: "FORM_SUBMITTED"})
}
